import { Link } from "react-router-dom";
import { appearances, yearRange } from "../format";
import type { TrackSummary } from "../types";
import { ArtistLinks } from "./ArtistLinks";
import { Cover } from "./Cover";

/** One song in a list (search results, artist page, discovery). */
export function TrackRow({ track, note }: { track: TrackSummary; note?: string }) {
  return (
    <li className="track-row">
      <Cover url={track.imageUrl} id={track.id} title={track.title} play={track} />
      <div className="track-row__main">
        <Link className="track-row__title" to={`/utwor/${track.id}`}>{track.title}</Link>
        <div className="track-row__artists"><ArtistLinks artists={track.artists} fallback={track.credit} /></div>
      </div>
      <div className="track-row__meta">
        <span>{yearRange(track.firstDate, track.lastDate)}</span>
        <span className="muted">{appearances(track.entries)} · najwyżej #{track.bestPosition}</span>
        {note && <span className="badge">{note}</span>}
      </div>
    </li>
  );
}
